 import * as React from 'react'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardMedia from '@mui/material/CardMedia'
import Typography from '@mui/material/Typography'
import { Box, Skeleton } from '@mui/material'
import useWeatherCall from 'src/@core/hooks/useWeatherCondition'
import Translations from 'src/@core/layouts/components/Translations'
import { t } from 'i18next'

interface WeatherProps {
  city: string
}

export default function WeatherCard({ city }: WeatherProps) {
  const weatherInfo = useWeatherCall(city)

  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ]

  if (weatherInfo === undefined) {
    return (
      <Skeleton
        variant='rectangular'
        className='weather-card'
        sx={{
          width: '100%',
          height: '260px',
          alignItems: 'center',
          borderRadius: '20px'
        }}
      />
    )
  }

  if (weatherInfo === null) {
    return null
  }

  return (
    <Card
      className='weather-card'
      sx={{
        minWidth: '250px',
        alignSelf: 'center',
        justifySelf: 'center',
        height: '260px',
        width: '100%',
        alignItems: 'center',
        borderRadius: '20px',
        backgroundColor: 'white !important',
      }}
    >
      <CardContent
        className='card-medio'
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
          }}
        >
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-around',
              mb: '12px',
              padding: '12px'
            }}
          >
            <Box sx={{ width: '60px' }}>
              <CardMedia component='img' src={weatherInfo?.current?.condition?.icon} alt='weather' />
            </Box>
            <Box sx={{ width: 'auto', textAlign: 'center', letterSpacing: '0.28px', lineHeight: 'normal' }}>
              <Typography
                variant='body2'
                color='text.secondary'
                sx={{ fontWeight: '400', color: '#B0B0B4', fontSize: '14px' }}
              >
                <Translations
                  text={
                    new Date().getUTCDate().toString() +
                    t(` ${monthNames[new Date().getMonth()]} `) +
                    new Date().getFullYear().toString()
                  }
                />
              </Typography>
              <Typography
                variant='body2'
                color='text.secondary'
                sx={{
                  fontWeight: '400',
                  color: 'black',
                  fontSize: '16px',
                  letterSpacing: '-0.36px',
                  lineHeight: '15px'
                }}
              >
                <Translations text={weatherInfo.current.condition.text} />
              </Typography>
            </Box>
            <Box>
              <Typography
                variant='body2'
                color='text.primary'
                sx={{ fontSize: '30px', fontWeight: '700', color: 'black', ml: 2 }}
              >
                {weatherInfo.current.temp_c + '°'}
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              height: '115px',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-around',
              alignItems: 'flex-start',
              width: '100%'
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 'auto',
                height: '100%'
              }}
            >
              <img src={'./Precipitaciones.png'} alt='humidity' />
              <Typography sx={{ color: '#B5B5B9', fontSize: '14px', mt: 1 }}>
                <Translations text={'Humidity'} />
              </Typography>
              <Typography
                variant='body2'
                color='text.secondary'
                sx={{ color: 'black', fontSize: '16px', fontWeight: 700, mt: 1 }}
              >
                {weatherInfo.current.humidity + '%'}
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 'auto',
                height: '100%'
              }}
            >
              <img src={'./Lluvias.png'} alt='humidity' />
              <Typography sx={{ color: '#B5B5B9', fontSize: '14px', mt: 1 }}>
                <Translations text={'Precipitations'} />
              </Typography>
              <Typography
                variant='body2'
                color='text.secondary'
                sx={{ color: 'black', fontSize: '16px', fontWeight: 700, mt: 1 }}
              >
                {weatherInfo.current.precip_mm + ' mm'}
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 'auto',
                height: '100%'
              }}
            >
              <img src={'./Viento.png'} alt='humidity' />
              <Typography sx={{ color: '#B5B5B9', fontSize: '14px', mt: 1 }}>
                <Translations text={'Wind'} />
              </Typography>
              <Typography
                variant='body2'
                color='text.secondary'
                sx={{ color: 'black', fontSize: '16px', fontWeight: 700, mt: 1 }}
              >
                {weatherInfo.current.wind_kph + ' Km/h'}
              </Typography>
            </Box>
          </Box>
        </Box>
      </CardContent>
    </Card>
  )
}
